import * as React from 'react';
import { Image, UIHeading1 } from '@cian/ui-kit';

import { ITurnInfo } from '../../../types/newbuilding';
import { Link } from '../../Link';

import { HousesByTurn } from '../components/HousesByTurn';
import * as styles from './NewbuildingInfoDesktop.css';

export interface ILink {
  key: string;
  onClick?(): void;
  title: string;
  url: string;
}

export interface INewbuildingInfoDesktopProps {
  favoriteButton: React.ReactNode;
  housesByTurn: ITurnInfo[];
  links: ILink[];
  newbuildingImage: string;
  newbuildingName: string;
  problemLabel?: React.ReactNode;
  reliableLabel?: React.ReactNode;
  statuses: string[];
  isExperimentalLocation: boolean;
}

export const NewbuildingInfoDesktop: React.VFC<INewbuildingInfoDesktopProps> = ({
  favoriteButton,
  housesByTurn,
  links,
  newbuildingImage,
  newbuildingName,
  statuses,
  reliableLabel,
  problemLabel,
  isExperimentalLocation,
}) => {
  // TODO удалить после подтверждения https://jira.cian.tech/browse/OM-912
  /* istanbul ignore next */
  const seoListClassName = React.useMemo(
    () => (isExperimentalLocation ? styles['statuses-experimental'] : styles['statuses']),
    [isExperimentalLocation],
  );

  return (
    <div data-testid="NewbuildingInfoDesktop">
      <div className={styles['content']}>
        <div className={styles['description']}>
          <div className={styles['title']}>
            <UIHeading1 as="h1" display="inline">
              Ход строительства ЖК «{newbuildingName}»
              <span>
                {reliableLabel}
                {problemLabel}
              </span>
            </UIHeading1>
            <ul className={seoListClassName}>
              {statuses.map((status, idx) => (
                <li key={idx}>{status}</li>
              ))}
            </ul>
          </div>
          {housesByTurn.length && <HousesByTurn housesByTurn={housesByTurn} />}
        </div>
        <div className={styles['image']}>
          <Image src={newbuildingImage} alt={`ЖК «${newbuildingName}»`} borderRadius={0} objectFit="cover" />
        </div>
      </div>

      <div className={styles['actions']}>
        <ul className={styles['links']}>
          {links.map(link => (
            <li key={link.key}>
              <Link href={link.url} onClick={link.onClick}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>

        {favoriteButton}
      </div>
    </div>
  );
};
